var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useRef } from 'react';
const usePreviousFileId = (currentFileId) => {
    _react_refresh_temp_1();
    const ref = useRef();
    useEffect(() => {
        ref.current = currentFileId;
    });
    return ref.current;
};
_react_refresh_temp_1(usePreviousFileId, "8uVE59eA/r6b92xF80p7sH8rXLk=");
export default usePreviousFileId;
